import type { FC } from "react";
import { Button } from "@/shared/ui/button";
import { useLanguage } from "@/core/LanguageContext";

type ErrorFallbackProps = {
  error: unknown;
  componentStack: string | null;
  eventId: string | null;
  resetError: () => void;
};

export const ErrorFallback: FC<ErrorFallbackProps> = ({ eventId, resetError }) => {
  const { t } = useLanguage();

  return (
    <div role="alert" className="min-h-screen gradient-card grid place-items-center p-6">
      <div className="w-full max-w-xl rounded-xl border bg-card p-6 shadow-elevated">
        <h1 className="mb-2 text-2xl font-semibold">
          {t("core.errorBoundary.title", "Something went wrong")}
        </h1>
        <p className="mb-4 text-sm text-muted-foreground">
          {t(
            "core.errorBoundary.description",
            "An unexpected UI error occurred. The issue has been reported automatically.",
          )}
        </p>
        {eventId ? (
          <p className="mb-4 text-xs text-muted-foreground">
            {t("core.errorBoundary.eventId", "Sentry event ID")}: <code>{eventId}</code>
          </p>
        ) : null}
        <div className="flex flex-wrap gap-2">
          <Button type="button" onClick={resetError}>
            {t("core.errorBoundary.tryAgain", "Try again")}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              window.location.assign("/");
            }}
          >
            {t("core.errorBoundary.goHome", "Go home")}
          </Button>
        </div>
      </div>
    </div>
  );
};
